export default __webpack_public_path__ + "static/media/sell-image3.359c433d.png";